module.exports = __webpack_public_path__ + "static/img/pic-zhou4.a5ccb49.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mainindex/pic-zhou4.jpg
// module id = 992
// module chunks = 0